import React from 'react'
import ButtonLink from '../Buttons/ButtonLink'
import { useNavigate } from 'react-router-dom'

const ConsultativeApproachSection = () => {
  const navigate = useNavigate()

  const data = [
    {
      icon: '/assets/images/icons/Tablice zadań.png',
      title: 'Tablice zadań',
      description: 'Tablice pozwalają: monitorować postęp prac w czasie rzeczywistym czy przypisywać zadania członkom zespołu. Każdy etap realizacji – od pierwszego kroku po zakończone działania – zawsze pod ręką. Możesz także oznaczyć zadanie jako zależne od innego – dzięki czemu zespół nie zacznie kolejnego kroku, zanim poprzedni nie zostanie ukończony.',
      link: '/funkcje/tablice-zadan'
    },
    {
      icon: '/assets/images/icons/Zarządzanie procesem projketowym.png',
      title: 'Zarządzanie procesem projektowym',
      description: 'Wykorzystaj pełną swobodę, by dostosować struktury projektów do specyfiki branży, zespołu oraz celów biznesowych. Z Kreatlo każdy etap pracy jest klarownie zaplanowany, a całość procesu przebiega zgodnie z ustalonymi zasadami, co gwarantuje efektywność i oszczędność czasu.',
      link: '/funkcje/proces-projektowy'
    },
    {
      icon: '/assets/images/icons/Wspópraca z wykonawcami.png',
      title: 'Współpraca z wykonawcami',
      description: 'Dzięki naszej platformie możesz szybko i efektywnie przekazywać wszystkie istotne informacje o projektach, np. do stolarzy, ogrodników, brukarzy, dekarzy, dostawców materiałów czy innych wykonawców. Udostępniaj etapy zadań, kosztorysy, dziel się szczegółowymi danymi i monitoruj postępy na każdym etapie.',
      link: '/funkcje/wspolpraca-wykonawcy'
    },
    {
      icon: '/assets/images/icons/Tworznie ofert wprost ze stron.png',
      title: 'Tworzenie ofert wprost ze strony internetowej',
      description: 'Jednym kliknięciem, bezpośrednio z dowolnej strony internetowej! Dzięki naszej wtyczce do przeglądarki, oszczędzasz czas i eliminujesz żmudne kopiowanie danych. Nasza wtyczka automatycznie pobierze zdjęcie, nazwę, cenę, dostawcę i link, wymiary, a Ty jedynie przypiszesz produkt do projektu. Szybko, wygodnie i bez zbędnego wysiłku – tworzenie oferty jeszcze nigdy nie było tak proste!',
      link: '/funkcje/oferty-ze-strony'
    }
  ]

  const pluses = [
    'Pełny dostęp do swojego profilu',
    'Decydujesz jakie dane kontaktowe udostępniasz',
    'Możliwość wgrania zdjęć projektów do swojego portfolio'
  ]

  return (
    <>
      <section className='tw-bg-white tw-py-0'>
        <div className='tw-bg-dark-teal tw-pt-20 md:tw-pt-28 xl:tw-pt-32 tw-pb-0'>
          <div className='tw-container xl:tw-max-w-7xl tw-mx-auto tw-px-4 lg:tw-px-0'>
            <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-8 xl:tw-gap-x-12'>
              <div>
                <div className='tw-bg-green tw-h-0.5 tw-w-60' />
                <h3 className='tw-mt-6 tw-text-lg sm:tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-4xl tw-font-bold tw-text-white'>Nowoczesna platforma dla designu przestrzeni</h3>
              </div>
              <div className='tw-mt-6 lg:tw-mt-0 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-6'>
                <div>
                  <p className='tw-mb-8 tw-text-xs md:tw-text-sm xl:tw-text-base tw-text-slate'>
                    Zaufaj rozwiązaniu, które jest dedykowane biurom projektowych i dołącz do grona profesjonalistów wykorzystujących nowoczesne technologie w codziennej pracy.
                  </p>

                  <button
                    onClick={() => {
                      const registrationSection = document.querySelector('#registration-section')
                      if (registrationSection != null) {
                        registrationSection.scrollIntoView({ behavior: 'smooth' })
                      }
                    }}
                    className='tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors tw-bg-green hover:tw-bg-opacity-90 tw-text-white tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base'
                  >
                    Wypróbuj za darmo
                  </button>
                </div>
                <div>
                  <p className='tw-text-xs md:tw-text-sm xl:tw-text-base tw-text-slate'>
                    Kreatlo to aplikacja stworzona w najnowszych technologiach, zapewniająca nie tylko niezawodność, ale także wyjątkową wygodę użytkowania. Nasze narzędzie pozwala efektywnie koordynować projekty, minimalizować błędy i optymalizować czas realizacji.
                    <br /><br />
                    Zadbaliśmy o nowoczesny i przejrzysty interfejs, który sprawia, że zarządzanie projektami staje się intuicyjne i przyjemne. Dzięki temu każdy użytkownik może skupić się na efektywnej pracy, bez zbędnej nauki obsługi systemu.
                  </p>
                </div>
              </div>
            </div>

            <ul className='tw-mt-16 lg:tw-mt-20 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-8'>
              {data.map((item, index) => (
                <li key={index} className='tw-mx-auto tw-max-w-xs tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-y-8 md:tw-gap-y-10 xl:tw-gap-y-12 tw-border tw-border-blue-100/50 tw-rounded-md tw-px-8 tw-py-12'>
                  <div className='tw-flex tw-flex-col tw-gap-y-4'>
                    <img src={item.icon} alt={item.title} className='tw-w-20 tw-h-20 tw-object-contain tw-mx-auto' />
                    <h4 className='tw-text-lg md:tw-text-xl tw-text-white tw-font-semibold tw-text-center'>{item.title}</h4>
                    <p className='tw-text-xs md:tw-text-sm tw-text-white tw-text-center'>{item.description}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className='tw-py-10 lg:tw-py-16 tw-max-w-sm'>
              <p className='tw-text-xs md:tw-text-sm xl:tw-text-lg tw-text-white tw-font-semibold'>Stwórz profesjonalną wizytówkę na naszej platformie wraz ze swoim portfolio!</p>
            </div>
          </div>
        </div>

        <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 lg:tw-gap-16 tw-mt-16 lg:tw-mt-0 tw-relative tw-container xl:tw-max-w-7xl tw-mx-auto lg:tw-pt-16 tw-px-4 lg:tw-px-0'>
          <div className='lg:tw-order-last'>
            <img src='/assets/images/icons/Zdjecia do wizytówka projektanta strona główna.png' alt='about' className='tw-w-full tw-h-full tw-object-contain tw-rounded-md tw-overflow-hidden' />
          </div>

          <div className='lg:tw-order-first tw-w-full lg:tw-grid lg:tw-gap-x-8 lg:tw-ml-8'>
            <p className='md:tw-my-auto tw-text-sm md:tw-text-base tw-tracking-wide tw-font-medium tw-text-center lg:tw-text-left'>
              Wizytówki na naszej platformie to doskonały sposób na zaprezentowanie swoich usług, doświadczenia i dotychczasowych realizacji. Ułatwi to kontakt z potencjalnymi Klientami, a także umożliwi budowanie profesjonalnego wizerunku w branży.
              <br />
              Podczas rejestracji, użytkownicy otrzymają pełną możliwość utworzenia swojej wizytówki oraz personalizacji swojego profilu, co pozwoli im wyróżnić się wśród innych profesjonalistów. Zarejestruj się na naszej platformie i daj się poznać szerokiemu gronu odbiorców!
            </p>

            <ul className='tw-mt-8 lg:tw-mt-0  tw-flex tw-flex-col tw-gap-y-2'>
              {pluses.map((item, index) => (
                <li key={index} className='tw-flex tw-gap-x-2'>
                  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' className='tw-w-5 tw-h-5 tw-flex-shrink-0 tw-text-green' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='20 6 9 17 4 12' />
                  </svg>
                  <span className='tw-text-md tw-font-semibold tw-text-teal'>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  )
}

export default ConsultativeApproachSection
